import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Detalhes do pedido',
  sections: {
    driver_info: 'Info do estafeta',
    order_info: 'Info do pedido',
    price_info: 'Info de preço',
    adjustments: 'Ajustes',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Takeaway',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviço de quarto',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviço de mesa',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Zimmernummer',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Tischnummer',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Este pedido está pendente de aprovação',
    [FULFILLMENT_STATUSES.reviewed]: 'Este pedido está pendente de aprovação',
    [FULFILLMENT_STATUSES.accepted]: 'Este pedido está a ser processado',
    [FULFILLMENT_STATUSES.preparing]: 'Este pedido está a ser processado',
    [FULFILLMENT_STATUSES.ready]: 'Este pedido está pronto para ser levantado pelo cliente',
    [FULFILLMENT_STATUSES.on_delivery]: 'Este pedido está a ser entregue ao cliente',
    [FULFILLMENT_STATUSES.picked]: 'Este pedido foi concluído com sucesso',
    [FULFILLMENT_STATUSES.rejected]: 'Este pedido foi rejeitado e reembolsado',
    default: 'Este pedido foi concluído com sucesso',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Solicitado pelo cliente',
    [REFUND_REASONS.Reclamation]: 'Reclamação',
    [REFUND_REASONS.CommunicationError]: 'Erro de comunicação',
    [REFUND_REASONS.Other]: 'Outro',
    [REFUND_REASONS.Dispute]: 'Disputa do cliente',
    dispute_win: 'Disputa ganha',
    null: '',
    undefined: '',
  },
  labels: {
    order_note: 'Nota da encomenda',
    discount: 'Desconto',
    driver_name: 'Nome do estafeta',
    driver_phone_number: 'Telefone do estafeta',
    pin_code: 'PIN',
    invoice_payment: 'Pagamento por fatura',
    paid_in_cash: 'Pagamento em dinheiro',
    customer_paid_online: 'Cliente pagou online',
    phone: 'Tel',
    email: 'Email',
    points_used: 'Este pedido inclui uma recompensa de pontos de fidelidade resgatada por um cliente fiel',
    delivery: 'Entrega',
    pickup: 'Takeaway',
    original: 'Original',
    delivery_fee: 'Taxa de entrega',
    tip: 'Gorjeta',
    service_fee: 'Processamento online',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Taxa PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Desconto percentual sobre o total aplicado',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Desconto percentual por produtos aplicado',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Desconto em valor por produtos aplicado',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Desconto em valor sobre o total aplicado',
      [OFFER_KIND.BOGO]: 'BOGO aplicado',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'BOGO meio preço aplicado',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Item gratuito por produtos aplicado',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Item gratuito por total aplicado',
      GiftCard: 'Cartão oferta aplicado',
      Reward: 'Pontos de fidelidade aplicados',
      CashbackAccount: 'Pontos de fidelidade aplicados',
      PromoCodeComponent: 'Promoção aplicada',
      Offer: 'Oferta aplicada',
    },
    total_discount: 'Promoção aplicada',
    tax: 'Impostos',
    total: 'Total',
    today: 'Hoje',
  },
  schedule: {
    header: 'Agendado para {{date}}, {{time}}',
    text: 'Iremos notificá-lo quando for altura de preparar o pedido',
  },
};
